interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = '确认',
  cancelLabel = '取消',
  danger = false,
  loading = false,
  onCancel,
  onConfirm,
}: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/40"
      onClick={loading ? undefined : onCancel}
    >
      <div
        className="bg-background-50 rounded-xl w-full max-w-md mx-4 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 py-4 border-b border-background-200 flex items-center gap-3">
          <div
            className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${
              danger ? 'bg-primary-100' : 'bg-accent-100'
            }`}
          >
            <i
              className={`${
                danger ? 'ri-error-warning-line text-primary-600' : 'ri-question-line text-accent-600'
              } text-lg`}
            />
          </div>
          <h3 className="text-sm font-semibold text-foreground-900">{title}</h3>
        </div>

        <div className="px-5 py-4">
          <p className="text-sm text-foreground-600 leading-relaxed">{message}</p>
        </div>

        <div className="px-5 py-4 border-t border-background-200 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-4 py-2 rounded-lg border border-background-300 text-foreground-600 text-sm hover:bg-background-100 transition-colors whitespace-nowrap disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`px-4 py-2 rounded-lg text-background-50 text-sm font-medium transition-colors whitespace-nowrap disabled:opacity-50 ${
              danger ? 'bg-primary-500 hover:bg-primary-600' : 'bg-accent-500 hover:bg-accent-600'
            }`}
          >
            {loading ? <i className="ri-loader-4-line animate-spin mr-1" /> : null}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
